import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PrinterProjectionDto} from "../../api/sca";

export interface ScaPrinterItem {
    label: string
    id: string
}

const systemApi = api.sca.api

class ScaPrinterStore {
    get options(): ScaPrinterItem[] {
        return this._options;
    }

    private set options(value: ScaPrinterItem[]) {
        this._options = value;
    }

    get loaded(): PrinterProjectionDto[] {
        return this._loaded;
    }

    set loaded(value: PrinterProjectionDto[]) {
        this._loaded = value;
    }

    get data(): PrinterProjectionDto[] {
        return this._data;
    }

    set data(value: PrinterProjectionDto[]) {
        this._data = value;
        this.options = this.buildOptions(value)
    }

    private _data: PrinterProjectionDto[] = [];
    private _loaded: PrinterProjectionDto[] = [];
    private _options: ScaPrinterItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => await systemApi.findZebraPrinters({
        }))
        this.data = result?.data || []
        this.loaded = this.data
    }

    async find(query?: string) {
        if (!query) {
            return this.load()
        }
        const result = await catchApi(async () => await systemApi.findZebraPrinters({
            query
        }))
        this.data = result?.data || []
    }

    reset() {
        this.data = this.loaded
    }

    private buildOptions(data: PrinterProjectionDto[]): ScaPrinterItem[] {
        return data.map(e => ({
            label: `${e.displayName} (${e.name})`,
            id: e.printerId
        }))
    }
}

const scaZebraPrinterStore = new ScaPrinterStore()

export {
    scaZebraPrinterStore
}
